<template>
  <div class="login-form">
    <div class="col-md-4 col-md-offset-4 login-form--to-center">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Please Sign In</h3>
        </div>
        <div class="panel-body">
          <fieldset>
            <div class="form-group">
              <label>Login (email)</label>
              <input
                v-model="email"
                class="form-control"
                placeholder="Login"
                name="login"
                autofocus
                autocomplete="off"
                @keyup.enter="onClickSubmit"
              />
            </div>
            <div class="form-group">
              <label v-show="bTemporaryPassword == false">Password</label>
              <input
                v-show="bTemporaryPassword == false"
                v-model="password"
                class="form-control"
                placeholder="Password"
                name="password"
                type="password"
                @keyup.enter="onClickSubmit"
              />
            </div>
            <div class="form-group" style="display:flex">
              <!--<button
                @click="onClickRequestAccess"
                type="submit"
                name="loginForm"
                value="check"
                class="btn btn-lg btn-success"
              >Request Access</button>
              &nbsp;-->
              <button
                v-show="bTemporaryPassword == false"
                type="submit"
                name="loginForm"
                value="check"
                class="btn btn-lg btn-success btn-block"
                @click="onClickSubmit"
              >
                Login
              </button>
            </div>
            <!-- CAMPI PASSWORD TEMPORANEA-->
            <div class="form-group">
              <label v-show="bTemporaryPassword == true">New password</label>
              <input
                v-show="bTemporaryPassword == true"
                v-model="newPassword"
                class="form-control"
                placeholder="New password"
                name="newPassword"
                type="password"
                @keydown="showPasswordError = false"
              />
            </div>
            <div class="form-group">
              <label v-show="bTemporaryPassword == true">Confirm new password</label>
              <input
                v-show="bTemporaryPassword == true"
                v-model="confirmNewPassword"
                class="form-control"
                placeholder="Confirm new password"
                name="confirmNewPassword"
                type="password"
                @keydown="showPasswordError = false"
              />
            </div>
            <div class="form-group" style="display:flex">
              <!--<button
                @click="onClickRequestAccess"
                type="submit"
                name="loginForm"
                value="check"
                class="btn btn-lg btn-success"
              >Request Access</button>
              &nbsp;-->
              <button
                v-show="bTemporaryPassword == true"
                type="submit"
                name="loginForm"
                value="check"
                class="btn btn-lg btn-success btn-block"
                @click="onClickNewPassword"
              >
                Change password
              </button>
            </div>
            <div v-show="showPasswordError">
              <h1 class="passwordError">Invalid new password!</h1>
              <p class="passwordError">Passwords must be at least 8 characters</p>
              <p class="passwordError">Passwords must have at least one lowercase ('a'-'z')</p>
              <p class="passwordError">Passwords must have at least one uppercase ('A'-'Z')</p>
              <p class="passwordError">Passwords must have at least one digit ('0'-'9')</p>
              <p class="passwordError">
                Passwords must have at least one non alphanumeric character
              </p>
            </div>
            <!--<div v-if="needEula && !bTemporaryPassword" class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title"></h4>
              </div>
              
              <div class="panel-body" style="max-height:300px;overflow:scroll;overflow-x: hidden;">
                <span v-if="EULAtext" v-html="EULAtext"></span>
                <span style="text-align: center">
                  <Loading :active="!EULAtext"></Loading>
                </span>
              </div>
              <div class="panel-body" style="height:300px;overflow:hidden;">
                <iframe
                  id="EULA"
                  src="La.html"
                  title="EULA"
                  style="width:100%;height:300px;border:none"
                ></iframe>
              </div>
              <div v-if="EULAtext" class="panel-footer">
              <div class="panel-footer">
                <hr />
                <input v-model="wrnChecked" type="checkbox" name="wrnChk" /><strong>Agree</strong
                ><br />
              </div>
            </div>-->
          </fieldset>

          <br />

          <VueRecaptcha
            ref="recaptcha"
            size="invisible"
            sitekey="6LdKrdsUAAAAAECgnxm17Lv7Wl63NtLRhcwJudjy"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          >
          </VueRecaptcha>
        </div>
        <div v-if="loading" class="status">loading...</div>
        <div v-if="error" class="error-message">{{ error }}</div>

        <hr v-if="cookieDisabled" />
        <div v-if="cookieDisabled" class="error-message">
          COOKIES ARE DISABLED.<br />The application may not work properly.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import generalService from "../services/backendCipriani/generalService";
import VueRecaptcha from "vue-recaptcha";
//import Loading from "vue-loading-overlay";
import Cookies from "js-cookie";

export default {
  name: "LoginForm",
  components: { VueRecaptcha /*, Loading */ },
  data() {
    return {
      // email: "account@ukr.net",
      // password: "Aa1234567_",
      email: "",
      password: "",
      newPassword: "",
      confirmNewPassword: "",
      error: null,
      loading: false,
      bTemporaryPassword: false,
      wrnChecked: false,
      //EULAtext: "",
      eulaOk: false,
      showPasswordError: false
    };
  },
  computed: {
    /*needEula: function() {
      if (!this.eulaOk) {
        let eulaOk = Cookies.get("EULA_OK");
        if (eulaOk) {
          if (eulaOk == "eulaOk") {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },*/
    cookieDisabled: function() {
      return !navigator.cookieEnabled;
    }
  },
  mounted: function() {
    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");
    /*
      Antonio C
      17/07/2020

      Su Google ho visto che l'unico modo
      per camabiare il font di un IFRAME
      è agire via codice
    */
    /*var frame = document.getElementById("EULA");
    frame.onload = function() {
      let body = frame.contentWindow.document.querySelector("body");
      body.style.fontFamily = "Segoe UI";
    };*/
    /*var that = this;
    that.EULAtext = "";
    generalService.getEULAText().then(function(data) {
      //setTimeout(() => {
      that.EULAtext = data;
      //}, 2000);
    });*/
  },
  methods: {
    parseError(err) {
      if (err.indexOf("401") >= 0) {
        return "Authorization Denied. Please check your credentials.";
      }
      if (err.indexOf("400") >= 0) {
        return "Authorization Denied. Please check your credentials.";
      }
      return this.uniTranslation(err);
    },
    onClickSubmit() {
      //MARCO B Commentata in seguito al cambiamento della gestione privacy
      //if (!(!this.wrnChecked && this.needEula)) {
      this.$store.commit("resetProgetti");
      this.$store.commit("clearUms");
      this.$refs.recaptcha.execute();
      //}
    },
    onCaptchaVerified() {
      /* recaptchaToken */
      const self = this;
      self.$refs.recaptcha.reset();
      self.onClickSubmit_AfterCaptcha();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },

    onClickSubmit_AfterCaptcha() {
      this.error = null;
      this.loading = true;
      var that = this;
      // console.log(this.email, this.password);
      that.$store
        .dispatch("loginUser", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          that.$store.dispatch("getUserInfo").then(() => {
            that.$store.dispatch("getUserInfoProfilo").then(() => {
              that.$store.dispatch("forceChangeLanguage", "en-US").then(() => {
                that.$store.dispatch("getSimboloValuta").then(() => {
                  //Cookies.set("EULA_OK", "eulaOk", { expires: 365 });
                  that.$store.commit("resetOffertaAttiva");
                  that.eulaOk = true;
                  if (that.$store.getters.loggedUserInfo.temporaryPassword == true) {
                    // alert("Password temporanea");
                    that.bTemporaryPassword = true;
                  } else {
                    that.$router.push("/");
                  }
                });
              });
            });
          });
        })
        .catch(err => {
          //alert(JSON.stringify(err));
          var error = "";
          if (err.response) {
            if (err.response.data) {
              if (err.response.data.message) {
                error = err.response.data.message;
              }
            }
          }
          if (err.message) {
            error = err.message;
          }
          that.error = that.parseError(error);
        })
        .finally(() => {
          that.loading = false;
        });
    },
    onClickNewPassword() {
      var that = this;

      var password1 = that.newPassword;
      var password2 = that.confirmNewPassword;

      if (password1 && password2) {
        if (password1 == password2) {
          if (that.password == that.newPassword) {
            that.error = "The new password must be different from the last one!";
          } else {
            // alert("Chiamata al server per cambio password");

            var isChangedPassword = false;

            that.$store
              .dispatch("changeUserPassword", {
                email: that.email,
                oldPassword: that.password,
                newPassword: that.newPassword
              })
              .then(data => {
                //alert("data = " + JSON.stringify(data));
                isChangedPassword = data;
              })
              .catch(err => {
                //alert(JSON.stringify(err));
                var error = "";
                if (err.response) {
                  if (err.response.data) {
                    if (err.response.data.message) {
                      error = err.response.data.message;
                    }
                  }
                }
                if (err.message) {
                  error = err.message;
                }
                that.error = that.parseError(error);
              })
              .finally(() => {
                if (isChangedPassword) {
                  that.password = "";
                  that.bTemporaryPassword = false;
                  that.showPasswordError = false;

                  // alert("password aggiornata");
                } else {
                  that.showPasswordError = true;
                }
              });
          }
        } else {
          that.error = "Please insert again the confirm new password!";
        }
      } else {
        if (!password1) {
          that.error = "Please insert new password!";
        } else if (!password2) {
          that.error = "Please confirm the new password!";
        }
      }
    }
    /*,
    onClickRequestAccess() {
      this.error = null;
      this.loading = true;
      this.$store
        .dispatch("requestLoginAccess", {
          email: this.email
        })
        .then(() => {
          this.message = "Request submitted.";
        })
        .catch(err => {
          this.error = err.response ? err.response.data.message : err;
        })
        .finally(() => {
          this.loading = false;
        });
    }*/
  }
};
</script>

<style lang="scss" scoped>
.passwordError {
  color: red;
}
.login-form {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;

  &--to-center {
    margin: 100px auto 0;
    @media (max-width: 425px) {
      margin: 30px auto 0;
    }
  }

  .error-message {
    color: tomato;
  }
}
</style>
